import { render, staticRenderFns } from "./consolidated-book.vue?vue&type=template&id=5060ff72"
import script from "./consolidated-book.vue?vue&type=script&lang=js"
export * from "./consolidated-book.vue?vue&type=script&lang=js"
import style0 from "./consolidated-book.vue?vue&type=style&index=0&id=5060ff72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports